export const SITE_NAME = 'Penland LLC';

const rawEnvUrl = ((import.meta.env.VITE_SITE_URL as string | undefined) ?? '').trim();
const normalizedEnvUrl = rawEnvUrl.replace(/\/+$/, '');

/**
 * Resolved website origin. Prefers the VITE_SITE_URL environment variable,
 * and falls back to the real runtime origin so no arbitrary domain is invented.
 */
export const SITE_URL =
  normalizedEnvUrl ||
  (typeof window !== 'undefined' ? window.location.origin.replace(/\/+$/, '') : '');

export const SITE_LOGO =
  'https://storage.readdy-site.link/project_files/66c63773-f4df-4b51-a232-b85a9487d8fb/a97ed8bf-79aa-4d6a-a5e7-b55b88780d52_compressed_Penland-LLC-Logo.webp';

export function absoluteUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${clean}`;
}